import ModalWrap from "../HBModal/ModalWrap";
import _PinUploader, { PinUploaderModal as Modal } from "./PinUploader";
import PinCreator from "./views";
import ModalWrapper from "./views/ModalWrapper";

export const PinUploaderModal = ModalWrap(Modal);
export const PinUploader = _PinUploader;
export const PinCreatorModal = ModalWrap(ModalWrapper);
export default PinCreator;
